/*!
 * WontRip Offer — Nájdi lacnejšie
 * v1.0 production (2026-04-24)
 * Requires: window.NAJDI_DB_CORE { w: [[handle,name,moc]], a: [[name,voc]] }
 * Lazy loads: window.NAJDI_DB_EXT { m: [[name,vocMin,vocMax,count]] } (Militaria)
 */
(function () {
  'use strict';

  var MARKUP = 1.6605;
  var WT_T = (window.WT_I18N && window.WT_I18N.offer) || {};
  function tr(k, fb) { return WT_T[k] || fb; }               // VOC (bez DPH B2B) × 1.35 marža × 1.23 SK DPH = MOC s DPH
  var SHIP_FREE_THRESHOLD = 99;      // EUR
  var EXT_ASSET = (window.WT_OFFER_EXT_URL || null); // injected by liquid

  // ----- utils -----
  function norm(t) { return (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
  function tokenize(t) { return norm(t).split(/[\s\-_,./]+/).filter(function (w) { return w.length > 1; }); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function fmt(n) { return '€' + Number(n).toFixed(2).replace('.', ','); }
  function $(id) { return document.getElementById(id); }

  // ----- URL parsing -----
  function parseURL(raw) {
    var url = (raw || '').trim();
    if (!url) return null;
    if (!/^https?:/i.test(url)) url = 'https://' + url;
    var source = null, slug = '';
    try {
      var u = new URL(url);
      var host = u.hostname.replace(/^www\./, '');
      if (host.indexOf('armyshop.cz') >= 0) {
        source = 'armyshop';
        slug = u.pathname.replace(/^\//, '').replace(/\/$/, '');
      } else if (host.indexOf('militaria.pl') >= 0) {
        source = 'militaria';
        var parts = u.pathname.split('/').filter(Boolean);
        slug = parts[parts.length - 1] || '';
      } else if (host.indexOf('wont.rip') >= 0) {
        // user pasted wont.rip URL — trivially "máme to"
        source = 'wontrip';
        var p = u.pathname.split('/').filter(Boolean);
        slug = p[p.length - 1] || '';
      }
    } catch (e) { return null; }
    if (!source) return null;
    var words = slug.replace(/-/g, ' ').replace(/_/g, ' ').replace(/\d{5,}/g, '').trim();
    return { source: source, slug: slug, words: words };
  }

  // ----- fuzzy matching -----
  function scoreMatch(qTokens, name) {
    var cTokens = tokenize(name);
    var cStr = norm(name);
    var matched = 0, totalW = 0;
    for (var i = 0; i < qTokens.length; i++) {
      var qt = qTokens[i];
      var isBrand = qt.length > 3 && /^[a-z]/.test(qt);
      var w = isBrand ? 1.5 : 1;
      totalW += w;
      if (cTokens.indexOf(qt) >= 0) matched += w;
      else if (cStr.indexOf(qt) >= 0) matched += w * 0.7;
      else if (qt.length >= 4) {
        var prefix = qt.substring(0, 4);
        for (var j = 0; j < cTokens.length; j++) {
          if (cTokens[j].indexOf(prefix) === 0) { matched += w * 0.4; break; }
        }
      }
    }
    return totalW === 0 ? 0 : matched / totalW;
  }

  // ----- DB search -----
  function searchCore(query, max) {
    max = max || 15;
    if (!window.NAJDI_DB_CORE) return [];
    var qTokens = tokenize(query);
    if (!qTokens.length) return [];
    var DB = window.NAJDI_DB_CORE;
    var results = [];
    // WontRip LIVE
    for (var i = 0; i < DB.w.length; i++) {
      var it = DB.w[i];
      var s = scoreMatch(qTokens, it[1]);
      if (s > 0.4) results.push({ type: 'have', name: it[1], moc: it[2], handle: it[0], score: s, url: 'https://wont.rip/products/' + it[0] });
    }
    // Armyshop
    for (var k = 0; k < DB.a.length; k++) {
      var a = DB.a[k];
      var sa = scoreMatch(qTokens, a[0]);
      if (sa > 0.4) results.push({ type: 'get', name: a[0], vocMin: a[1], vocMax: a[1], count: 1, score: sa, wontripMoc: Math.ceil(a[1] * MARKUP * 100) / 100, supplier: 'Armyshop.cz' });
    }
    // Militaria (if loaded)
    if (window.NAJDI_DB_EXT && window.NAJDI_DB_EXT.m) {
      var M = window.NAJDI_DB_EXT.m;
      for (var m = 0; m < M.length; m++) {
        var mm = M[m];
        var sm = scoreMatch(qTokens, mm[0]);
        if (sm > 0.4) results.push({ type: 'get', name: mm[0], vocMin: mm[1], vocMax: mm[2], count: mm[3], score: sm, wontripMoc: Math.ceil(mm[1] * MARKUP * 100) / 100, supplier: 'Militaria.pl' });
      }
    }
    results.sort(function (A, B) {
      if (A.type === 'have' && B.type !== 'have') return -1;
      if (B.type === 'have' && A.type !== 'have') return 1;
      return B.score - A.score;
    });
    return results.slice(0, max);
  }

  // ----- lazy load ext DB -----
  var extLoaded = false, extLoading = null;
  function loadExt() {
    if (extLoaded) return Promise.resolve();
    if (extLoading) return extLoading;
    if (!EXT_ASSET) return Promise.resolve(); // no ext DB configured
    extLoading = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = EXT_ASSET;
      s.async = true;
      s.onload = function () { extLoaded = true; resolve(); };
      s.onerror = function () { resolve(); }; // fail silent, core still works
      document.head.appendChild(s);
    });
    return extLoading;
  }

  // ----- shipping calc -----
  function selectedShipping() {
    var r = document.querySelector('input[name="wt-ship"]:checked');
    return r ? parseFloat(r.value) : 3.49;
  }
  function shippingLabel() {
    var r = document.querySelector('input[name="wt-ship"]:checked');
    if (!r) return 'Packeta Z-POINT';
    var map = { '3.49': 'Packeta Z-POINT', '5.99': tr('ship_courier', 'Kuriér na adresu'), '7.49': tr('ship_cod', 'Dobierka') };
    return map[r.value] || tr('delivery', 'Doručenie');
  }
  function priceWithShipping(price) {
    var ship = selectedShipping();
    // free shipping at Z-POINT threshold
    if (ship === 3.49 && price >= SHIP_FREE_THRESHOLD) return { total: price, ship: 0, free: true };
    return { total: price + ship, ship: ship, free: false };
  }

  // ----- rendering -----
  function renderShippingRow(price) {
    var p = priceWithShipping(price);
    if (p.free) {
      return '<div class="wt-total"><span class="wt-total-lbl">' + tr('total_with_delivery', 'Spolu s doručením') + '</span><span class="wt-total-val">' + fmt(p.total) + '</span><span class="wt-free">' + tr('free_shipping', 'Doprava ZADARMO') + '</span></div>';
    }
    return '<div class="wt-total"><span class="wt-total-lbl">' + tr('total', 'Spolu') + ': ' + fmt(price) + ' + ' + shippingLabel() + ' ' + fmt(p.ship) + '</span><span class="wt-total-val">' + fmt(p.total) + '</span></div>';
  }

  function renderResults(results, srcURL) {
    var out = $('wt-offer-results');
    if (!results.length) {
      out.innerHTML = '<div class="wt-result">' +
        '<div class="wt-badge wt-badge-none">' + tr('badge_none', 'Nenašli sme zhodu') + '</div>' +
        '<div class="wt-result-name">' + tr('none_title', 'Pre tento produkt nemáme match v našej databáze') + '</div>' +
        '<p style="color:#888;font-size:14px;margin:8px 0 14px;">' + tr('none_text', 'Skús iný názov alebo nás kontaktuj — zoženieme ti čokoľvek od našich 10+ európskych B2B partnerov.') + '</p>' +
        '<a href="/pages/kontakt?subject=' + encodeURIComponent(tr('subject_get_product', 'Zohnať produkt')) + '&ref=' + encodeURIComponent(srcURL || '') + '" class="wt-cta wt-cta-outline">' + tr('write_us', 'Napíš nám — zoženieme to') + '</a>' +
        '</div>';
      return;
    }
    var best = results[0];
    var html = '';

    if (best.type === 'have') {
      var price = best.moc;
      html += '<div class="wt-result">' +
        '<div class="wt-badge wt-badge-have">' + tr('badge_have', 'Máme to skladom') + '</div>' +
        '<div class="wt-result-name">' + esc(best.name) + '</div>' +
        '<div class="wt-price-grid">' +
          '<div class="wt-price-box"><div class="wt-lbl">' + tr('our_price', 'Naša cena s DPH') + '</div><div class="wt-val green">' + fmt(price) + '</div></div>' +
          '<div class="wt-price-box"><div class="wt-lbl">' + tr('availability', 'Dostupnosť') + '</div><div class="wt-val" style="font-size:15px;color:#22c55e;">' + tr('in_stock_at', 'Skladom na wont.rip') + '</div></div>' +
        '</div>' +
        renderShippingRow(price) +
        '<a href="' + best.url + '" class="wt-cta">' + tr('view_product', 'Zobraziť produkt na WontRip') + ' &rarr;</a>' +
      '</div>';
    } else {
      var p2 = best.wontripMoc;
      html += '<div class="wt-result">' +
        '<div class="wt-badge wt-badge-get">' + tr('badge_get', 'Zoženiem ti to') + '</div>' +
        '<div class="wt-result-name">' + esc(best.name) + '</div>' +
        '<div class="wt-result-source">' + tr('available_via', 'Dostupné cez') + ' ' + esc(best.supplier) + '</div>' +
        '<div class="wt-price-grid">' +
          '<div class="wt-price-box"><div class="wt-lbl">' + tr('est_price', 'Orientačná cena s DPH') + '</div><div class="wt-val green">' + fmt(p2) + '</div><div class="wt-note">' + tr('final_price_note', 'Konečná cena vrátane DPH 23 %') + '</div></div>' +
          '<div class="wt-price-box"><div class="wt-lbl">' + tr('delivery_time', 'Dodacia doba') + '</div><div class="wt-val" style="font-size:15px;color:#c8a54a;">' + tr('delivery_days', '3–7 pracovných dní') + '</div></div>' +
        '</div>' +
        renderShippingRow(p2) +
        (best.count > 1 ? '<div style="font-size:12px;color:#888;margin-bottom:10px;">' + best.count + ' ' + tr('variants_available', 'veľkostí / variantov dostupných u dodávateľa') + '</div>' : '') +
        '<a href="/pages/kontakt?subject=' + encodeURIComponent(tr('subject_get', 'Zohnať') + ': ' + best.name) + '&ref=' + encodeURIComponent(srcURL || '') + '" class="wt-cta">' + tr('interested', 'Mám záujem — napíš mi') + '</a>' +
      '</div>';
    }

    // alt results
    var others = results.slice(1, 8);
    if (others.length) {
      html += '<div class="wt-result"><div class="wt-others-title">' + tr('more_matches', 'Ďalšie zhody') + ' (' + others.length + ')</div><div class="wt-others">';
      for (var o = 0; o < others.length; o++) {
        var r = others[o];
        var price2 = r.type === 'have' ? r.moc : r.wontripMoc;
        var supplier = r.type === 'have' ? 'Skladom na wont.rip' : (r.supplier || '');
        html += '<div class="wt-mini">' +
          '<div><div class="wt-mini-name">' + esc(r.name) + '</div><div class="wt-mini-supplier">' + esc(supplier) + '</div></div>' +
          '<div class="wt-mini-price' + (r.type === 'have' ? ' green' : '') + '">' + fmt(price2) + '</div>' +
        '</div>';
      }
      html += '</div></div>';
    }

    out.innerHTML = html;
  }

  // ----- event handlers -----
  function showLoading() {
    $('wt-offer-results').innerHTML = '<div class="wt-loading"><div class="wt-spin"></div><br>' + tr('loading', 'Hľadám v katalógoch…') + '</div>';
  }
  function doURLSearch() {
    var raw = $('wt-url').value.trim();
    if (!raw) return;
    var parsed = parseURL(raw);
    if (!parsed) {
      $('wt-offer-results').innerHTML = '<div class="wt-result">' +
        '<div class="wt-badge wt-badge-none">' + tr('badge_unsupported', 'Nepodporovaný web') + '</div>' +
        '<div class="wt-result-name">' + tr('unsupported_title', 'Aktuálne podporujeme armyshop.cz a militaria.pl') + '</div>' +
        '<p style="color:#888;font-size:14px;margin:8px 0 0;">' + tr('unsupported_text', 'Pre iné weby skús hľadať podľa názvu produktu nižšie, alebo nám napíš.') + '</p>' +
      '</div>';
      return;
    }
    showLoading();
    loadExt().then(function () {
      var res = searchCore(parsed.words);
      renderResults(res, raw);
    });
  }
  function doTextSearch() {
    var q = $('wt-text').value.trim();
    if (q.length < 2) return;
    showLoading();
    loadExt().then(function () {
      var res = searchCore(q);
      renderResults(res, null);
    });
  }

  // re-render on shipping change if result card visible
  function bindShippingChange() {
    var radios = document.querySelectorAll('input[name="wt-ship"]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function () {
        // re-run last search to update totals
        if ($('wt-url').value.trim()) doURLSearch();
        else if ($('wt-text').value.trim()) doTextSearch();
      });
    }
  }

  function init() {
    if (!window.NAJDI_DB_CORE) {
      $('wt-offer-results').innerHTML = '<div class="wt-loading" style="color:#ef4444">' + tr('db_error', 'Chyba načítania databázy. Skús obnoviť stránku.') + '</div>';
      return;
    }
    var totalCore = window.NAJDI_DB_CORE.w.length + window.NAJDI_DB_CORE.a.length;
    $('wt-offer-stats').style.display = 'flex';
    $('wt-offer-stats').innerHTML =
      '<span><strong>' + window.NAJDI_DB_CORE.w.length.toLocaleString('sk') + '</strong> ' + tr('products_live', 'produktov WontRip live') + '</span>' +
      '<span><strong>' + window.NAJDI_DB_CORE.a.length.toLocaleString('sk') + '</strong> Armyshop</span>' +
      '<span><strong>37K+</strong> Militaria (load on-demand)</span>';
    $('wt-btn-url').disabled = false;
    $('wt-btn-text').disabled = false;
    $('wt-btn-url').addEventListener('click', doURLSearch);
    $('wt-btn-text').addEventListener('click', doTextSearch);
    $('wt-url').addEventListener('keydown', function (e) { if (e.key === 'Enter') doURLSearch(); });
    $('wt-text').addEventListener('keydown', function (e) { if (e.key === 'Enter') doTextSearch(); });
    bindShippingChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
